import React, { Component } from 'react';
import { connect } from 'react-redux';
import { validateForm } from 'redux/ducks/Post';
import { switchLocation, switchStep } from 'redux/ducks/Post/Navigation';
import HorizontalRule from 'components/HorizontalRule';
import { Button } from 'reactstrap';
import { addNewLocation, deleteLocation } from 'redux/ducks/Post/Locations/actions';
import ConfirmationModal from 'components/V2/ConfirmationModal';
import { formattedLocation } from 'helpers/post';
import { trackMixpanelPageView } from 'helpers/post';
import { get } from 'lodash';
import { changeDetailsField } from 'redux/ducks/Post/Details';
import { AddButton, DeleteButton } from 'components/V2/Buttons';

class LocationScreen extends Component {
  constructor(props) {
    super(props);
    props.initialize('LocationsIntroScreen');
  }

  state = {
    locationsModal: false,
    deleteModal: false,
  };

  toggleDeleteModal = () => this.setState(prevState => ({ ...prevState, deleteModal: !this.state.deleteModal }))

  toggleLocationsModal = () =>
    this.setState({ locationsModal: !this.state.locationsModal });

  componentDidMount() {
    const locationsModal = get(this.props, 'location.state.showModal', false);
    this.setState({ locationsModal });

    if (this.props.history.location.pathname.includes('create-event'))
      trackMixpanelPageView('create-event/all-locations', this.props.user);
  }

  switchLocation = (no) => {
    this.props.switchLocation(no - 1);
    this.props.switchStep('location');
  };

  onEditLocation = (idx) => () => {
    this.switchLocation(idx + 1);
    this.props.history.push(`${this.props.baseUrl}/location`);
  };

  onDeleteLocation = (location) => () => {
    this.props.onDeleteLocation({
      locationId: location.id,
      locationIndex: location.idx,
    });
  };

  setLocations = (value) => {
    this.props.onDetailsChange('locationsNo', Math.min(value, 50));
  };

  addLocation = (num) => () => {
    const newLocations = Number(this.props.details.locationsNo || 0) + num;
    this.setLocations(newLocations < 1 ? 1 : newLocations);
    this.props.addNewLocation();
  };

  render() {
    return (
      <div className="locations-screen">
        <div className="nav-placeholder" />
        <main className="intro">
          <header>
            <div className="screen-title">All Locations</div>
          </header>
          <div className="tournament-title gotham-bold-font">{this.props.profile.title}</div>
          <HorizontalRule margin={0} />
          {this.props.locations.map((location, idx) => (
            <React.Fragment key={idx}>
              <div className="location-item py-2">
                <span className="location-label mr-2 inline-block">
                  LOCATION {idx + 1}
                </span>
                <span>{formattedLocation(location) || 'Not Started'}</span>
                <div className="actions">
                  <AddButton
                    className="gotham-regular-font edit-btn"
                    onClick={this.onEditLocation(location.idx)}
                  >
                    {location.formattedAddress ? 'Edit' : 'Start'}
                  </AddButton>
                  <DeleteButton
                    show={this.props.locations.length > 1}
                    onClick={this.toggleDeleteModal}
                    className='delete'
                  >
                    Delete
                  </DeleteButton>
                  <ConfirmationModal
                    title="Delete Location"
                    body="Deleting this location will remove all shifts associated with it."
                    onSave={this.onDeleteLocation(location)}
                    onCancel={this.toggleDeleteModal}
                    confirmText="Delete"
                    cancelText="Go Back"
                    isOpen={this.state.deleteModal}
                    toggle={this.toggleDeleteModal}
                  />
                </div>
              </div>
              {idx !== this.props.locations.length && (
                <HorizontalRule dashed margin={0} />
              )}
            </React.Fragment>
          ))}
          <div>
            <AddButton
              className="gotham-regular-font add-location"
              onClick={this.addLocation(1)}
            >
              Add Location
            </AddButton>
          </div>
        </main>
        <ConfirmationModal
          isOpen={this.state.locationsModal}
          toggle={this.toggleLocationsModal}
          title="Edit Locations"
          body="To remove a location, delete it from this page."
          confirmText="Close"
          onSave={this.toggleLocationsModal}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state.post,
  authenticated: state.session.authenticated,
  user: state.session.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
  validateForm: () => dispatch(validateForm('locations')),
  switchLocation: (idx) => dispatch(switchLocation({ locationIdx: idx })),
  switchStep: (step) => dispatch(switchStep(step)),
  onDeleteLocation: (payload) => dispatch(deleteLocation(payload)),
  addNewLocation: () =>
    dispatch(addNewLocation()),
  onDetailsChange: (name, value) =>
    dispatch(changeDetailsField({ name, value })),
});

export default connect(mapStateToProps, mapDispatchToProps)(LocationScreen);
